'use client';

import { useEffect, useState } from 'react';
import { readLiveConfigurationPrice, type LiveConfigurationPrice } from '@/lib/product-options/live-price';

export function ConfiguredPriceSummary({ productId, locale }: { productId: string; locale: string }) {
  const [price, setPrice] = useState<LiveConfigurationPrice | null>(null);
  const copy = ({
    nl: { title: 'Totaal voor jouw uitvoering', pending: 'Stel samen voor je prijs', hint: 'Kies je opties en aantal. Je totaalprijs verschijnt hier.' },
    en: { title: 'Total for your selection', pending: 'Configure to see your price', hint: 'Choose your options and quantity. Your total will appear here.' },
    de: { title: 'Gesamtpreis für deine Auswahl', pending: 'Konfigurieren und Preis berechnen', hint: 'Wähle Optionen und Menge. Dein Gesamtpreis erscheint hier.' },
    fr: { title: 'Total pour votre configuration', pending: 'Configurez pour connaître votre prix', hint: 'Choisissez vos options et la quantité. Votre total s’affichera ici.' },
  } as Record<string, { title: string; pending: string; hint: string }>)[locale] || { title: 'Total', pending: 'Configure to see your price', hint: 'Choose your options and quantity.' };

  useEffect(() => {
    const update = (event: Event) => {
      const detail = (event as CustomEvent).detail;
      if (detail?.productId !== productId) return;
      setPrice(readLiveConfigurationPrice(detail, productId));
    };
    window.addEventListener('printen:pricing', update);
    return () => window.removeEventListener('printen:pricing', update);
  }, [productId]);

  return <div className="mb-4 min-h-20" aria-live="polite" aria-atomic="true" data-configured-price-summary>
    <p className="text-sm font-medium text-slate-500">{price ? copy.title : copy.pending}</p>
    {price && <p className="text-2xl font-semibold tracking-tight text-slate-900 sm:text-[28px]">{price.totalLabel}</p>}
    <p className="text-[13px] text-slate-500 sm:text-sm">{price ? price.subLabel : copy.hint}</p>
  </div>;
}
